import { createRelationships as _createRelationships } from '@griply/services';
import { MinimalRelationship } from '@griply/types';
import {
  collection,
  doc,
  serverTimestamp,
  setDoc,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getAuthentication, getDatabase } from './helpers';

export const createRelationships = async (
  relationships: MinimalRelationship[],
) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  await _createRelationships({
    relationships,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.CreateRelationships,
        error,
        uid: user.uid,
      }),
  });
};
